import React from "react"
import './StartBlock.scss'
import { Button, Container } from "react-bootstrap";

function StartBlock() {
    return (
        <div className="start-block">
            <div className="desktop-start-wrapper d-none d-xl-block">
                <div className="title-block">
                    <Container>
                        <div className="title1">Международная олимпиада</div>
                        <div className="title2">по русскому языку</div>
                    </Container>
                </div>
                <div className="registration-block">
                    <Container>
                        <div className="registration-text">
                            {`Регистрация \nс 21 сентября по 18 октября`}
                        </div>
                        <Button className='invite-button' as="a" variant="secondary" href={`/`}>
                            принять участие
                        </Button>
                    </Container>
                </div>
                <div className="down-block"></div>
                <div className="portrait-block">
                    <div className="portrait">
                        <div className="circle"></div>
                        <div className="fullname">Владимир Иванович Даль</div>
                        <div className="years">1801—1872</div>
                    </div>
                    <a className="open-xh" href='/gallery'>
                        <div className="text">открыть выставку</div>
                        <div className="arrow"></div>
                    </a>
                </div>
            </div>

            <div className="mobile-start-wrapper d-xl-none">
                <Container>
                    <div className="mobile-title-block">
                        <div className="title1">Международная олимпиада</div>
                        <div className="title2">по русскому языку</div>
                    </div>
                </Container>

                <div className="mobile-registration-block">
                    <Container className="text-center">
                        <div className="registration-text">
                            {`Регистрация \nс 21 сентября по 18 октября`}
                        </div>
                        <Button className='invite-button' as="a" variant="secondary" href={`/`}>
                            принять участие
                        </Button>
                    </Container>
                </div>

                <div className="mobile-portrait-block">
                    <div className="portrait">
                        <div className="portrait-image-wrapper">
                            <div className="circle"></div>
                        </div>
                        <div className="portrait-info">
                            <div className="fullname">Владимир Иванович Даль</div>
                            <div className="years">1801—1872</div>
                        </div>
                    </div>
                    
                    <a className="open-xh" href='/gallery'>
                        <div className="text">открыть выставку</div>
                        <div className="arrow"></div>
                    </a>
                </div>
            </div>
        </div>
    );
}

export default StartBlock;
